(function filteringPlugin(global) {
  "use strict";

  var SELECT_LIST_PAGE_SIZE = 50;
  var SPECIAL_VALUE = global._controls.selectList.SPECIAL_VALUE;
  var DATE_SPECIAL_VALUE = global._controls.selectList.DATE_SPECIAL_VALUE;

  /**
  * Плагин для фильтра таблицы.
  *
  * @class WebAccess.components.dataViews.gridPlugins.FilteringPlugin
  * @extends WebAccess.Plugin
  * @param {WebAccess.dataViews.grid.BaseDataProvider} selectListDataProvider Класс, предоставляющий данные для компоненты selectList
  * @property {string} name Имя плагина
  * @property {integer} groupDisplayLimit Максимальная длина отображаемого значения фильтра по колонке
  * @property {WebAccess.dataViews.grid.BaseDataProvider} selectListDataProvider Класс, предоставляющий данные для компоненты selectList
  * @since 5.2.0.1100
  */
  var FilteringPlugin = global.FilteringPlugin = WA.Plugin.extend({

    name: 'FilteringPlugin',
    groupDisplayLimit: 40,
    selectListDataProvider: null,

    _grid: null,
    _controls: [],
    _selectListContainerSelector: '.selectList',
    _popupSelector: '.selectListPopup',
    _slickHeaderSelector: '.slick-headerrow',
    _dataPickerInputSelector: '.dateField',
    _datePickerSelector: '.ui-datepicker',
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    init: function (selectListDataProvider) {
      var me = this;
      me._super();
      me._controls = [];
      if (!!selectListDataProvider) me.selectListDataProvider = selectListDataProvider;
      else WA.raise('SELECT_LIST_DATA_PROVIDER_IS_REQUIRED');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Регистрирует плагин.
    *
    * @method WebAccess.components.dataViews.gridPlugins.FilteringPlugin#register
    * @param {WebAccess.components.dataViews.Grid} grid Таблица
    * @since 5.2.0.1100
    * @return {object} Ассоциативный массив, содержащий публичные методы.
    */
    register: function (grid) {
      var me = this;
      me._grid = grid;
      me._grid.bind(WA.CMP.DV.Grid.EVENT.GRID_INIT, WA.TCD($.proxy(me._onGridInit, me)));
      return {
        toggleFiltering: me._toggleFiltersArea_exported,
        updateFilter: $.proxy(me._updateFilter_exported, me),
        getFillingRequisites: $.proxy(me._getFillingRequisites, me)
      };
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Показ/скрытие облсти фильтрации
    * @method WebAccess.components.dataViews.gridPlugins.FilteringPlugin#_toggleFiltersArea_exported
    * @private
    * @this {grid}
    * @since 5.2.0.1100
    */
    _toggleFiltersArea_exported: function (needToEnable) {
      var me = this;
      log.debug('GRID', 'Toggling filter area: ' + needToEnable);

      var jArea = $(me._slickHeaderSelector, me._selectListContainerSelector);

      if (needToEnable) {
        jArea.show();
        me.grid.setHeaderRowVisibility(true);
        me.grid.resizeViewport();
        me.updateState({ IsFilterPanelVisible: true }, true);
      } else {
        jArea.hide();
        me.grid.setHeaderRowVisibility(false);
        me.grid.resizeViewport();
        me.updateState({ IsFilterPanelVisible: false }, true);
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Обработчик события инициализации грида.
    * @method WebAccess.components.dataViews.gridPlugins.FilteringPlugin#_onGridInit
    * @private
    * @return {WebAccess.components.dataViews.gridPlugins.FilteringPlugin}
    * @since 5.2.0.1100
    */
    _onGridInit: function () {
      var me = this;
      var columnFilters = {};

      var CF = me._grid.state.CurrentFilter;
      me._updateFilterExpression()

      me._grid.updateState({ CurrentFilter: CF });
      (!!me._grid.updateFooter) && me._grid.updateFooter();

      me._grid.toggleFiltering(me._grid.state.IsFilterPanelVisible);

      // Закрытие всех выпадающих списоков всех контролов.
      $(document).mouseup(function (e) {
        var container = $(me._popupSelector).add(me._datePickerSelector).add(me._dataPickerInputSelector);
        if (!container.is(e.target) && container.has(e.target).length === 0 && e.target != $('html').get(0)) {
          _(me._controls).each(function (control) {
            var jTarget = $(e.target);
            if (!!jTarget.attr("id")) {
              if (jTarget.attr("id") !== control.instanceID) control.close();
            } else {
              control.close();
            }
          });
        }
      });

      //При фильтрации, обновим у всех контролов выражение фильтрации
      //У того контрола по которому идет фильтрация, выражение выпилим
      me.bind(FilteringPlugin.EVENT.FILTER_UPDATE, function (filter, expression) {
        _(me._controls).each(function (control) {
          control.state.expression = me._getColumnExpression(filter, control.state.column.id);
        });
      });

      me._grid.grid.onHeaderRowCellRendered.subscribe($.proxy(me.renderControl, me));
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Создает поле фильтрации.
    *
    * @method  WebAccess.components.dataViews.gridPlugins.FilteringPlugin#renderControls
    * @since 5.2.0.1100
    * @return {WebAccess.components.dataViews.gridPlugins.FilteringPlugin}
    */
    renderControl: function (event, data) {
      var me = this;
      var closeOtherControls = function (control) {
        _(_(me._controls).filter(function (c) {
          return control.instanceID !== c.instanceID
        })).each(function (c) {
          c.close();
        });
      }

      var column = data.column;
      var grid = data.grid;
      var container = data.node;
      var columnFilters = me._grid.state.CurrentFilter.ColumnsFilter;
      switch (column.type) {
        case 'Integer':
        case 'LargeInteger':
        case 'Float':
        case 'String':
        case 'Pick':
        case 'Document':
        case 'Reference':
          var SelectList = global._controls.selectList.SelectListControl;
          var columnFilter = (!!columnFilters) ? columnFilters[column.id] : null;

          var like = (columnFilter) ? columnFilter.Like : '';
          var selectedRecords = (!!columnFilter && columnFilter.Type == 'In') ? columnFilter.In : [];
          var notSelectedRecords = (!!columnFilter && columnFilter.Type == 'Exclude') ? columnFilter.In : [];
          var invertedMode = !!notSelectedRecords.length;

          var selectList = new SelectList(container, new me.selectListDataProvider(me._grid.settings.selectListDataProviderSettings), {
            column: column,
            requisiteName: column.id,
            take: SELECT_LIST_PAGE_SIZE,
            skip: 0,
            page: 0,
            expression: me._getColumnExpression(columnFilters, column.id),
            like: like,
            selectedRecords: selectedRecords, //CREVIEW Шамов А.: Название selectedRecords больше относится к справочнику, может переименуем в selectedItems? //поздно уже это менять
            notSelectedRecords: notSelectedRecords,
            invertedMode: invertedMode,
            plugins: [new global._controls.selectList.SpecialValuesPlugin()]
          });

          //Скрывать все остальные открытые контролы, когда текущий открыт
          selectList.bind(SelectList.EVENT.BEFORE_LIST_OPEN, $.proxy(closeOtherControls, me));
          selectList.bind(SelectList.EVENT.VALUE_CHANGED, function (value) { me._updateStateAndReloadData(column, value); });
          me._controls.push(selectList);
          break;

        case 'Date':
          var SelectList = global._controls.selectList.SelectListControl;
          var columnFilter = (!!columnFilters) ? columnFilters[column.id] : null;

          var like = (columnFilter) ? columnFilter.Like : '';
          var selectedRecords = (!!columnFilter && columnFilter.Type == 'In') ? columnFilter.In : [];
          var notSelectedRecords = (!!columnFilter && columnFilter.Type == 'Exclude') ? columnFilter.In : [];
          var invertedMode = !!notSelectedRecords.length;

          var selectList = new SelectList(container, new me.selectListDataProvider(me._grid.settings.selectListDataProviderSettings), {
            column: column,
            requisiteName: column.id,
            take: SELECT_LIST_PAGE_SIZE,
            skip: 0,
            page: 0,
            expression: me._getColumnExpression(columnFilters, column.id),
            like: like,
            selectedRecords: selectedRecords, //CREVIEW Шамов А.: Название selectedRecords больше относится к справочнику, может переименуем в selectedItems? //поздно уже это менять
            notSelectedRecords: notSelectedRecords,
            invertedMode: invertedMode,
            plugins: [
              new global._controls.selectList.DateValuesPlugin(),
              new global._controls.selectList.SpecialValuesPlugin()
            ]
          });

          //Скрывать все остальные открытые контролы, когда текущий открыт
          selectList.bind(SelectList.EVENT.BEFORE_LIST_OPEN, $.proxy(closeOtherControls, me));
          selectList.bind(SelectList.EVENT.VALUE_CHANGED, function (value) { me._updateStateAndReloadData(column, value); });
          me._controls.push(selectList);

          break;
        case 'Empty':
          $(container).append('<br/><br/>');
          break;
        default:
          $.noop();
      }
      return me;
    },

    /**
    * Обновление фильтрации грида при смене значения в одном из контролов
    * @method WebAccess.components.dataViews.gridPlugins.FilteringPlugin#_updateStateAndReloadData
    * @private
    * @return {WebAccess.components.dataViews.gridPlugins.FilteringPlugin}
    * @since 5.2.0.1100
    */
    _updateStateAndReloadData: function (column, value) {
      var me = this;
      log.debug('GRID', 'Updating filter');

      var CF = me._grid.state.CurrentFilter;
      var isPrevAutoFilter = (CF.ID == '0');
      var isPrevEmptyFilter = (CF.ID == '-1');

      CF.ColumnsFilter[column.id] = value;
      me._updateFilterExpression();

      CF.IsNeedSave = true;
      // Если фильтра больше нет, то сбросим его совсем.
      if (CF.Expression === '') {
        $.extend(CF, {
          ID: '-1',
          Name: '',
          ColumnsFilter: {}
        });

        // Удалим автофильтр.
        delete me._grid.state.SavedFilters['0'];

        if (Filters && Filters.resetFilter) Filters.resetFilter();
      } else {
        CF.ID = '0';
        if (!CF.Name || !isPrevAutoFilter) {
          CF.Name = me._getAutoFilterName();
        }

        // Обновим или добавим имя автосохраненного фильтра в список сохраненных.
        me._grid.state.SavedFilters[CF.ID] = CF.Name;

        // Включим новый фильтр, даже если предыдущий был выключен.
        CF.IsEnabled = true;
      }

      //Обновляем контекстное меню в ленте.
      if (Filters && Filters.setupFiltersState) Filters.setupFiltersState();

      me._grid.updateState({
        CurrentFilter: CF,
        PageIndex: 0
      });

      me.fire(FilteringPlugin.EVENT.FILTER_UPDATE, CF.ColumnsFilter, CF.Expression);

      if (!!me._grid.updateFooter) me._grid.updateFooter();

      // Сбросить выделение
      me._grid.grid.setSelectedRows([]);

      me._grid.reloadData();
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Обновление выражения фильтрации и состояние контролов.
    * @method WebAccess.components.dataViews.gridPlugins.FilteringPlugin#_updateFilter_exported
    * @private
    * @return {WebAccess.components.dataViews.gridPlugins.FilteringPlugin}
    * @since 5.2.0.1100
    */
    _updateFilter_exported: function () {
      var me = this;
      me._updateFilterExpression();
      me._updateControlsState();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Обновления выраженяи фильтрации.
    * @method WebAccess.components.dataViews.gridPlugins.FilteringPlugin#_updateFilterExpression
    * @private
    * @return {WebAccess.components.dataViews.gridPlugins.FilteringPlugin}
    * @since 5.2.0.1100
    */
    _updateFilterExpression: function () {
      var me = this;
      var CF = me._grid.state.CurrentFilter;
      $.extend(CF, {
        ColumnsFilter: me._removeDeniedColumns(CF.ColumnsFilter),
        Expression: me._convertToSBRSE(CF.ColumnsFilter),
        DisplayValue: me._convertToHumanRedableText(CF.ColumnsFilter, true),
        DisplayHint: me._convertToHumanRedableText(CF.ColumnsFilter)
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Удалить колонки из фильтра если фильтрация по ним невозможна
    * @method WebAccess.components.dataViews.gridPlugins.FilteringPlugin#_removeDeniedColumns
    * @private
    * @since 5.2.0.1100
    * @see #98783
    */
    _removeDeniedColumns: function (filter) {
      var me = this;
      var allColumnsIds = _(me._grid._columns).pluck('id');
      _(filter).each(function (f, name) {
        if (allColumnsIds.indexOf(name) === -1) {
          delete filter[name];
        }
      });
      return filter;
    },

    /**
    * Получить имя "автофильтра"
    * @method WebAccess.components.dataViews.gridPlugins.FilteringPlugin#_updateStateAndReloadData
    * @private
    * @return {String}
    * @since 5.2.0.1100
    */
    _getAutoFilterName: function () {
      var filters = this._grid.state.SavedFilters;
      var maxFilterID = _(_(_(filters).keys()).map(function (k) {
        return +k; // Преобразуем в число, что бы вычислить max.
      })).max();
      return L('AUTO_FILTER_LABEL') + ' ' + Math.max(maxFilterID + 1, 1); //Если фильтров нет, то max вернет -Infinity, а имя фильтра сделаем с номером 1.
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Преобразовние объекта фильтра в человеко-читаемую строку для футера
    * @method WebAccess.components.dataViews.gridPlugins.FilteringPlugin#_convertToHumanRedableText
    * @private
    * @return {WebAccess.components.dataViews.gridPlugins.FilteringPlugin}
    * @since 5.2.0.1100
    */
    _convertToHumanRedableText: function (filter, needTrunc) {
      var me = this;
      needTrunc = !!needTrunc;

      var expression = _(filter).map(function (reqFilter, requsiteName) {
        var expression = '';

        var column = _(me._grid._columns).find(function (col) {
          return col.id == requsiteName;
        });

        var columnName = column.name;

        switch (reqFilter.Type) {
          case 'Exclude':
            expression = _(reqFilter.In).map(function (record) {
              if (record.Type && record.Type === SPECIAL_VALUE.BLANK) return columnName + wrapWith.space(L('NOT')) + L('CHOICE_BLANK');
              if (record.Type && record.Type === SPECIAL_VALUE.NOBLANK) return columnName + wrapWith.space(L('NOT')) + L('CHOICE_NONBLANK');
              return columnName + wrapWith.space(L('NOT')) + $.trim(record.DisplayValue);
            }).join(wrapWith.space(L('FILTER_OR')));
            break;

          case 'In':
            expression = _(reqFilter.In).map(function (record) {
              if (record.Type && record.Type === SPECIAL_VALUE.BLANK) return columnName + wrapWith.space('=') + L('CHOICE_BLANK');
              if (record.Type && record.Type === SPECIAL_VALUE.NOBLANK) return columnName + wrapWith.space('=') + L('CHOICE_NONBLANK');
              return columnName + wrapWith.space('=') + $.trim(record.DisplayValue);
            }).join(wrapWith.space(L('FILTER_OR')));
            break;
          case 'Like':
            if (reqFilter.Like) expression = columnName + wrapWith.space(L('FILTER_CONTAINS')) + reqFilter.Like;
            break;
          case 'Equal':
            if (column.type === 'Date') {
              if (!!reqFilter.Equal) {
                var d = Date.fromISO(reqFilter.Equal);
                if (!isNaN(d.getTime())) {
                  //Формат должен зависить от языка веб-доступа.
                  var formatFunc = (column.dateType === 'DateTime' ? formatDateTime : formatDate);
                  expression = columnName + wrapWith.space('=') + formatFunc(d);
                }
              }
            } else {
              if (reqFilter.Equal) {
                expression = columnName + wrapWith.space('=') + reqFilter.Equal;
              }
            }
            break;
        }

        expression = needTrunc ? expression.trunc(me.groupDisplayLimit) : expression;
        if (!!expression) expression = wrapWith.group(expression);
        return expression;
      });

      expression = _(expression).compact().join(wrapWith.space(L('FILTER_AND')));
      return expression;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Преобразовние объекта фильтра в строку-выражение SBRSE;
    * @method WebAccess.components.dataViews.gridPlugins.FilteringPlugin#_convertToHumanRedableText
    * @private
    * @return {WebAccess.components.dataViews.gridPlugins.FilteringPlugin}
    * @since 5.2.0.1100
    */
    _convertToSBRSE: function (filter) {
      var me = this;

      var expression = _(filter).map(function (reqFilter, requsiteName) {
        var expression = null;

        var column = _(me._grid._columns).find(function (col) {
          return col.id == requsiteName;
        });

        var getDateFilter = function (record, mode) {
          if (record.Type && record.Type === DATE_SPECIAL_VALUE.YESTERDAY) {
            var yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return expression = me._makeOneDayDateExpression(requsiteName, yesterday);
          }

          if (record.Type && record.Type === DATE_SPECIAL_VALUE.TODAY) return expression = me._makeOneDayDateExpression(requsiteName, new Date());
          if (record.Type && record.Type === DATE_SPECIAL_VALUE.TOMORROW) {
            var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            return expression = me._makeOneDayDateExpression(requsiteName, tomorrow);
          }

          if (record.Type && record.Type === DATE_SPECIAL_VALUE.THIS_WEEK) {
            var curr = new Date();
            var day = curr.getDay()
            firstDay = new Date(curr.getFullYear(), curr.getMonth(), curr.getDate() + (day == 0 ? -6 : 1) - day);
            lastDay = new Date(curr.getFullYear(), curr.getMonth(), curr.getDate() + (day == 0 ? 0 : 7) - day);
            return expression = me._makeDateBetweenExpression(requsiteName, firstDay, lastDay);
          }

          if (record.Type && record.Type === DATE_SPECIAL_VALUE.THIS_MONTH) {
            var curr = new Date();
            var firstDay = new Date(curr.getFullYear(), curr.getMonth(), 1);
            var lastDay = new Date(curr.getFullYear(), curr.getMonth() + 1, 0);
            return expression = me._makeDateBetweenExpression(requsiteName, firstDay, lastDay);
          }

          if (record.Type && record.Type === DATE_SPECIAL_VALUE.THIS_YEAR) {
            var curr = new Date();
            var firstDay = new Date(curr.getFullYear(), 0, 1);
            var lastDay = new Date(curr.getFullYear(), 11, 31);
            return expression = me._makeDateBetweenExpression(requsiteName, firstDay, lastDay);
          }
        }

        switch (reqFilter.Type) {
          case 'Exclude':
            if (!reqFilter.In.length) return null;
            expression = '!' + wrapWith.group(_(reqFilter.In).map(function (record) {
              if (record.Type && record.Type === SPECIAL_VALUE.BLANK) return wrapWith.block(requsiteName) + ' = NULL';
              if (record.Type && record.Type === SPECIAL_VALUE.NOBLANK) return wrapWith.block(requsiteName) + ' != NULL';

              var dateFilter = getDateFilter(record);
              if (dateFilter) return dateFilter;

              var operand = (column.type === "String" ? 'matches' : '=');
              return wrapWith.block(requsiteName) + ' ' + operand + ' "' + record.Value + '"';
            }).join(' | '));
            break;

          case 'In':
            expression = _(reqFilter.In).map(function (record) {
              if (record.Type && record.Type === SPECIAL_VALUE.BLANK) return wrapWith.block(requsiteName) + ' = NULL';
              if (record.Type && record.Type === SPECIAL_VALUE.NOBLANK) return wrapWith.block(requsiteName) + ' != NULL';

              var dateFilter = getDateFilter(record);
              if (dateFilter) return dateFilter;

              if (column.type === 'Date') {
                var likeExpr = me._makeDateTimeLikeExpression(requsiteName, record.Value, column.dateType);
                if (!!likeExpr) expression = likeExpr;
                return expression;
              }

              var operand = (column.type === "String" ? 'matches' : '=');
              return wrapWith.block(requsiteName) + ' ' + operand + ' "' + record.Value + '"';
            }).join(' | ');
            break;

          case 'Like':
            // Like должен работать по отображаемому значению, а для справочника и признака он хранится вдругом месте.
            var value = reqFilter.Like.replaceAll('%', '[%]').replaceAll('"', '\\"');

            var displayValueFieldName = requsiteName;
            switch (column.type) {
              case 'Reference':
              case 'Document':
              case 'Pick':
                displayValueFieldName = column.field;
                break;
              case 'Float':
                value = value.replaceAll(',', '.');
                break;
            }
            if (reqFilter.Like) expression = wrapWith.block(displayValueFieldName) + ' like "%' + value + '%"';

            if (column.type === 'Date' && !!reqFilter.Like) {
              var likeExpr = me._makeDateLikeExpression(requsiteName, reqFilter.Like, column.dateType);
              if (!!likeExpr) expression = likeExpr;
            }
            break;
          case 'Equal':
            if (column.type === 'Date' && !!reqFilter.Equal) {
              // Для совместимости со старыми фильтрами.
                var d = Date.fromISO(reqFilter.Equal);
                if (!isNaN(d.getTime())) {
                var likeExpr = me._makeDateTimeLikeExpression(requsiteName, d, column.dateType);
                if (!!likeExpr) expression = likeExpr;
              }
            } else {
              if (reqFilter.Equal) {
                expression = wrapWith.block(requsiteName) + ' = ' + reqFilter.Equal;
              }
            }
            break;
        }

        return wrapWith.group(expression);
      })

      expression = _(expression).compact().join(' & ');
      return expression;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    
    /**
     * Формирует выражение фильтрации для like по указанной дате или дате со временем.
     *
     * @method WebAccess.components.dataViews.gridPlugins.FilteringPlugin#_makeDateTimeLikeExpression
     * @param {string} requsiteName Имя реквизита.
     * @param {string} likeValue Значение для фильтрации.
     * @param {string} dateType Тип даты.
     * @private
     * @return {string} Выражение фильтрации.
     */
    _makeDateTimeLikeExpression(requsiteName, likeValue, dateType) {      
      const dateValue = (typeof likeValue === 'string') ? parseDateTime(likeValue) : likeValue;

      if (this._isDateTimeCorrect(dateValue)) {
        if (dateType === 'DateTime') {
          const fromDate = formatDateTime(dateValue, 'dd.mm.yy hh:mm:00', false);
          const toDate = formatDateTime(new Date(dateValue.getTime() + 60000), 'dd.mm.yy hh:mm:00'); //+1 мин.          
          return `(${wrapWith.block(requsiteName)} >= #${fromDate}# & ${wrapWith.block(requsiteName)} < #${toDate}#)`;
        } else {
          return this._makeOneDayDateExpression(requsiteName, dateValue);
        }
      }
      return '';
    },
        
    /**
     * Формирует выражение фильтрации для like по указанной дате.
     *
     * @method WebAccess.components.dataViews.gridPlugins.FilteringPlugin#_makeDateLikeExpression
     * @param {string} requsiteName Имя реквизита.
     * @param {string} likeValue Значение для фильтрации.     
     * @private
     * @return {string} Выражение фильтрации.
     */
    _makeDateLikeExpression(requsiteName, likeValue) {      
      const dateValue = (typeof likeValue === 'string') ? parseDateTime(likeValue) : likeValue;
      if (this._isDateTimeCorrect(dateValue)) {
        return this._makeOneDayDateExpression(requsiteName, dateValue);
      }
      return '';      
    },
    
    /**
     * Проверяет корректность даты.
     *
     * @method WebAccess.components.dataViews.gridPlugins.FilteringPlugin#_isDateTimeCorrect
     * @param {object} dateValue Дата.
     * @private
     * @return {boolean} TRUE, если дата корректная, иначе - FALSE.
     */
    _isDateTimeCorrect(dateValue) {                  
      return dateValue && dateValue.getFullYear() < 10000 && !isNaN(dateValue.getTime());
    },
    
    // Формирует выражение фильтрации по дате за один день.
    _makeOneDayDateExpression: function (requsiteName, d) {
      return this._makeDateBetweenExpression(requsiteName, d, d);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    // Формирует выражение фильтрации по интервалу дат.
    _makeDateBetweenExpression: function (requsiteName, d, d2) {
      var expression = '(' + wrapWith.block(requsiteName) + ' >= #' + formatDate(d, 'dd.mm.yy') + ' 00:00:00# & ';
      expression += wrapWith.block(requsiteName) + ' < #' + formatDate(new Date(d2.getTime() + 24 * 3600000), 'dd.mm.yy') + ' 00:00:00#)';
      return expression;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    _getColumnExpression: function (filter, columnId) {
      var me = this;
      var currentFilter = _(filter).clone();
      delete currentFilter[columnId];
      var currentFilterExpr = me._convertToSBRSE(currentFilter);

      var GF = me._grid.state.GlobalPageFilter;
      if (GF) {
        if (currentFilterExpr) {
          return '(' + GF + ') & (' + currentFilterExpr + ')';
        } else {
          return GF;
        }
      } else {
        return currentFilterExpr;
      }
    },

    /**
    * Получение значений фильтрации для заполнения новой записи
    * @method WebAccess.components.dataViews.gridPlugins.FilteringPlugin#_getFillingRequisites
    * @private
    */
    _getFillingRequisites: function () {
      var me = this;
      var requisites = {};
      var value;
      _(me._controls).each(function (control) {
        var requsiteName = control.state.requisiteName;

        var column = _(me._grid._columns).find(function (col) {
          return col.id == requsiteName;
        });


        if (control.className === 'SelectListControl') {
          value = control.getValue();

          if (value.Type === 'In') {
            var record = value.In[0];

            if (!record) return;

            var today = new Date();

            switch (record.Value) {
              case SPECIAL_VALUE.BLANK:
              case SPECIAL_VALUE.NOBLANK:
              case SPECIAL_VALUE.ALL:
                return
                break
              case DATE_SPECIAL_VALUE.YESTERDAY:
                today.setDate(today.getDate() - 1);
                requisites[requsiteName] = formatDateTime(today);
                return
                break
              case DATE_SPECIAL_VALUE.TODAY:
                requisites[requsiteName] = formatDateTime(today);
                return
                break
              case DATE_SPECIAL_VALUE.TOMORROW:
                today.setDate(today.getDate() + 1);
                requisites[requsiteName] = formatDateTime(today);
                return
            }


            switch (column.type) {
              case 'String':
                requisites[requsiteName] = record.DisplayValue
                break;
              case 'Date':
                var d = parseDateTime(record.Value);
                if (!d) return;
                if (d.getFullYear() > 9999) return;

                requisites[requsiteName] = formatDateTime(d);
                break;
              default:
                requisites[requsiteName] = record.Value;
            }
          }

          if (value.Type === 'Equal' || value.Type === 'Like') {
            if (column.type === 'Date') {
              var date = value.Equal || value.Like;

              var d = parseDateTime("" + date);
              if (!d) return;
              if (d.getFullYear() > 9999) return;
              requisites[requsiteName] = formatDateTime(d);
            }
          }

        };
      });
      return $.toJSON(requisites);
    },

    _updateControlsState: function () {
      var me = this;
      var CF = me._grid.state.CurrentFilter;
      var columnFilters = CF.ColumnsFilter;
      _(me._controls).each(function (c) {
        var column = c.state.column;
        switch (c.className) {
          case 'SelectListControl':

            var columnFilter = (!!columnFilters) ? columnFilters[column.id] : null;

            var like = (columnFilter) ? columnFilter.Like : '';
            var selectedRecords = (!!columnFilter && columnFilter.Type == 'In') ? columnFilter.In : [];
            var notSelectedRecords = (!!columnFilter && columnFilter.Type == 'Exclude') ? columnFilter.In : [];
            var invertedMode = !!notSelectedRecords.length;

            c.updateState({
              skip: 0,
              page: 0,
              expression: me._getColumnExpression(columnFilters, column.id),
              like: like,
              notSelectedRecords: notSelectedRecords,
              invertedMode: invertedMode,
              selectedRecords: selectedRecords
            });
            break;
          case 'DateControl':
            var equalValue = (columnFilters && columnFilters[column.id]) ? columnFilters[column.id].Equal : '';
            c.updateState({
              value: equalValue
            });
            break;
        }
      });
    }

  }, {
    EVENT: {
      FILTER_UPDATE: 'filterUpdate'
    }
  });

  /**
  * Оборачивание строки в различные скобки
  * @inner
  */
  var wrapWith = {
    group: function (str) {
      if (!str) return str;
      return '(' + str + ')';
    },
    block: function (str) {
      if (!str) return str;
      return '[' + str + ']';
    },
    space: function (str) {
      if (!str) return str;
      return ' ' + str + ' ';
    }
  }

})(WA.components.dataViews.gridPlugins);
